import axios from "axios";
import useAuthStore from "../store/authStore";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://scit45dango.site";

const api = axios.create({
  baseURL: API_BASE_URL,
});

// 요청 인터셉터: 토큰 자동 주입
api.interceptors.request.use(
  (config) => {
    if (config.url?.includes("/auth/login")) {
      return config;
    }

    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터: 401 시 토큰 갱신 시도, 실패 시 로그아웃
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && originalRequest?.url?.includes("/auth/login")) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const { user, logout } = useAuthStore.getState();

      // refreshToken이 있으면 갱신 시도
      if (user?.refreshToken) {
        try {
          const res = await axios.post(`${API_BASE_URL}/auth/token/refresh`, {
            refreshToken: user.refreshToken,
          });
          const newToken = res.data.accessToken;
          // 백엔드의 Refresh Token Rotation 정책상 응답에 새 refreshToken 도 함께 옴.
          // 이를 store 에 갱신하지 않으면 다음 갱신 시점에 옛 refreshToken 이 전송되어
          // 서버가 도용으로 간주, 강제 로그아웃 처리한다.
          const newRefreshToken = res.data.refreshToken ?? user.refreshToken;
          useAuthStore.getState().login({
            token: newToken,
            user: { ...user, refreshToken: newRefreshToken },
          });
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          logout();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      } else {
        logout();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
